import { API, graphqlOperation } from "aws-amplify";

import { getCloudinarySignature } from "api/graphql/queries";

const stringifyContext = (context) => {
  if (!context) {
    return "";
  }

  if (typeof context === "string") {
    return context;
  }

  return Object.entries(context)
    .filter(
      ([, value]) => value !== undefined && value !== null && value !== ""
    )
    .map(([key, value]) => `${key}=${value}`)
    .join("|");
};

export const CloudinaryUpload = async ({ file, publicId, context }) => {
  const uploadPreset = process.env.REACT_APP_CLOUDINARY_UPLOAD_PRESET_RESUME;
  const cloudName = process.env.REACT_APP_CLOUDINARY_CLOUDNAME;
  const contextString = stringifyContext(context);

  if (!uploadPreset) {
    throw new Error("Cloudinary resume upload preset is not configured");
  }

  if (!cloudName) {
    throw new Error("Cloudinary cloud name is not configured");
  }

  if (!publicId) {
    throw new Error("Resume upload public id is missing");
  }

  const signatureResponse = await API.graphql(
    graphqlOperation(getCloudinarySignature, {
      publicId,
      preset: uploadPreset,
      context: contextString,
    })
  );

  const signature = signatureResponse.data.getCloudinarySignature;

  const formData = new FormData();
  formData.append("public_id", publicId);
  formData.append("upload_preset", uploadPreset);
  formData.append("context", contextString);
  formData.append("source", "uw");
  formData.append("file", file);

  if (signature?.signature && signature?.apiKey && signature?.timestamp) {
    formData.append("signature", signature.signature);
    formData.append("timestamp", signature.timestamp.toString());
    formData.append("api_key", signature.apiKey);
  }

  const uploadResponse = await fetch(
    `https://api.cloudinary.com/v1_1/${cloudName}/auto/upload`,
    {
      method: "POST",
      body: formData,
    }
  );

  if (!uploadResponse.ok) {
    const errorText = await uploadResponse.text();
    throw new Error(
      `Upload failed: ${uploadResponse.statusText} - ${errorText}`
    );
  }

  const uploadResult = await uploadResponse.json();

  return { publicId: uploadResult.public_id, url: uploadResult.secure_url };
};
